import { signOut } from "firebase/auth";
import React from "react";
import { Link } from "react-router-dom";
import { auth } from "../firebase/firebase";
import { message } from "antd";
import { useAuth } from "../App";

export const Navigation = () => {
  const { user } = useAuth();

  const logout = async () => {
    try {
      await signOut(auth);
      message.success("Logout successful!");
    } catch (error) {
      console.error("Logout Error:", error.message);
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            NIKOON
          </a>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            {user ? (
              <li>
                <Link onClick={logout} to="/login" className="page-scroll">
                  Logout
                </Link>
              </li>
            ) : (
              <>
                <li><a href="#gallery" className="page-scroll">Gallery</a></li>
                <li><a href="#package" className="page-scroll">Package</a></li>
                <li><a href="#calendar" className="page-scroll">Calendar</a></li>
                <li><a href="#contact" className="page-scroll">Contact</a></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
